import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { CursoService } from '../services/curso-service.service';  
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-modal-pago',
  templateUrl: './modal-pago.component.html',
  styleUrls: ['./modal-pago.component.css']
})
export class ModalPagoComponent implements OnInit {

  @Input() valorPagar: number = 0; 
  @Input() agendamiento: any; 
  @Output() close = new EventEmitter<void>(); 

  constructor(
    private cursoService: CursoService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
  }

  // confirmarPago(): void {
  //   this.spinnerService.show();
    
  //   if (this.valorPagar && this.agendamiento) {
  //     const buyer = {
  //       document_type: this.agendamiento.tipo_documento,
  //       document_number: this.agendamiento.rutpaciente,
  //       sex: this.agendamiento.genero,
  //       birthdate: this.agendamiento.fecha_nacimiento, 
  //       mail: this.agendamiento.correopaciente,
  //       first_name: this.agendamiento.nombrepaciente.split(' ')[0],
  //       paternal_lastname: this.agendamiento.nombrepaciente.split(' ')[1],
  //       maternal_lastname: this.agendamiento.nombrepaciente.split(' ')[2],
  //     };
  
  //     const metadata = { ...this.agendamiento };
  //     const valorPagar = parseInt(this.valorPagar.toString().replace(/[^0-9]/g, ''), 10);
  
  //     this.cursoService.realizarPago(valorPagar, buyer, metadata).subscribe(
  //       (response) => {
  //         if (response.linkPayment) {
  //           window.location.href = response.linkPayment; 
  //         } else {
  //           console.error('Error: No se recibió un enlace de pago válido');
  //         }
  //       },
  //       (error) => {
  //         this.spinnerService.hide();
  //         console.error('Error al realizar el pago:', error);
  //       }
  //     );
  //   } else {
  //     this.spinnerService.hide();
  //     console.error('Error: valorPagar o agendamiento no están definidos');
  //   }
  // }
  

  closeModal(): void {
    this.close.emit();
  }
}